<template>
  <base-popup
    class="payouts-registry-format-popup"
    ref="popup"
    :without-icon="true"
  >
    <template #content>
      <div class="payouts-registry-format-popup__title">
        {{ $t('payouts.by-registry.popup.title') }}
      </div>
      <div
        class="payouts-registry-format-popup__points"
        v-html="$t('payouts.by-registry.popup.points')"
      ></div>
      <div class="payouts-registry-format-popup__ex-title">
        {{ $t('payouts.by-registry.popup.example-title') }}
      </div>
      <div class="payouts-registry-format-popup__ex-image">
        <img
          :src="$options.PayoutsRegistryExampleIcon"
          alt="payouts registry example"
        />
      </div>
    </template>
    <template #actions="{ close }">
      <div class="payouts-registry-format-popup__actions">
        <primary-button
          class="payouts-registry-format-popup__actions-item"
          @click="downloadExample"
          :label="$t('payouts.by-registry.popup.actions.download-example')"
        ></primary-button>
        <no-bg-button
          class="payouts-registry-format-popup__actions-item"
          @click="close"
          :label="$t('payouts.by-registry.popup.actions.close')"
        ></no-bg-button>
      </div>
    </template>
  </base-popup>
</template>

<script>
import BasePopup from '@vue-app/components/base/popup/BasePopup.vue'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'
import NoBgButton from '@vue-app/components/base/button/NoBgButton.vue'
import PayoutsRegistryExampleIcon from '@js-app/assets/payouts/by-registry/payouts-registry-example.png'
import { downloadBlob } from '@js-app/services/helpers/download'

export default {
  name: 'PayoutsRegistryFormatPopup',
  components: { NoBgButton, PrimaryButton, BasePopup },

  EXAMPLE_DATA: [
    ['4149571279372381', '25000', 'Шевченко Тарас Петрович'],
    ['5355571279805122', '150000', 'Леся Українка'],
    ['5355576952813958', '80000', 'Коцюбинський Михайло Михайлович'],
  ],

  PayoutsRegistryExampleIcon,

  methods: {
    open() {
      return this.$refs.popup.open()
    },
    downloadExample() {
      fetch('/docs/examples/xpay-payouts-exemple.xlsx')
        .then((response) => response.blob())
        .then((blob) => {
          downloadBlob(blob, 'payouts-registry-example.xlsx')
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.payouts-registry-format-popup {
  :deep(.popup) {
    max-width: 840px;
    width: 100%;
    padding: 53px 90px 35px;

    .popup__actions {
      margin-top: 14px;
    }
  }

  &__title {
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    align-items: center;
    color: #27365b;
    margin-bottom: 32px;
  }

  &__points {
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    text-align: left;
    color: #67768a;
    margin-bottom: 22px;
  }

  &__ex-title {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    text-align: left;
    color: #27365b;
    margin-bottom: 10px;
  }

  &__ex-image {
    width: 100%;
    max-width: 440px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
    }
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &-item {
      padding: 13px 35px;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
